import { useSelector } from 'react-redux';
import { useGetTasksQuery, useFetchMoreTasksMutation } from 'redux-stores/tasks/tasksApi';
import type { TasksSliceState } from 'redux-stores/tasks/tasksSlice';

export type TasksFilter = 'active' | 'completed';

type UseFilterTasksProps = {
  filter: TasksFilter;
  orgId?: string;
  skip: boolean;
};
const useFilterTasks = ({ filter, orgId, skip }: UseFilterTasksProps) => {
  const apiFilter = filter === 'active' ? 'open' : 'completed';
  const organizationId = orgId ?? '';
  const { data: tasks = [], isLoading } = useGetTasksQuery(
    { organizationId, filter: apiFilter },
    { skip }
  );
  const [fetchMoreTasks, { isLoading: isFetchingNextPage }] = useFetchMoreTasksMutation();
  const nextCursor = useSelector(
    (state: { tasks: TasksSliceState }) =>
      state.tasks.nextCursorByKey[`${organizationId}:${apiFilter}`] ?? null
  );
  const hasNextPage = nextCursor !== null;

  const fetchNextPage = () => {
    if (!skip && hasNextPage && !isFetchingNextPage) {
      fetchMoreTasks({ organizationId, filter: apiFilter });
    }
  };

  return {
    tasks: isLoading ? [] : tasks,
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  };
};

export default useFilterTasks;
